import React from "react";

const SimContext = React.createContext({});

export default SimContext;
